import React from 'react'

import PropTypes from 'prop-types'

import { Text } from './styled'

const RegularText = ({ children, margin, padding, textAlign }) => (
  <Text padding={padding} margin={margin} textAlign={textAlign}>
    {children}
  </Text>
)

RegularText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  margin: PropTypes.string,
  padding: PropTypes.string,
  textAlign: PropTypes.string,
}

RegularText.defaultProps = {
  children: '',
  margin: '',
  padding: '',
  textAlign: '',
}

export default RegularText
